var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetterP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9954,
    cy: 11.8821,
    r: 11.3821,
    fill: "#DAE8FD",
    stroke: "#0277AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2228 16H9.11776V6.965H12.5498C14.4868 6.965 15.7218 7.992 15.7218 9.656C15.7218 11.333 14.5128 12.347 12.5498 12.347H10.2228V16ZM10.2228 7.94V11.372H12.5498C13.8368 11.372 14.5518 10.748 14.5518 9.656C14.5518 8.551 13.8368 7.94 12.5498 7.94H10.2228Z",
    fill: "#0277AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterP);
export default __webpack_public_path__ + "static/media/letterP.5f7e374a39d23c7a666ccc7bb3ce2950.svg";
export { ForwardRef as ReactComponent };